import { BadgeCheck } from "lucide-react";

export const SoldBadge = ({ count, testId }) =>
  count > 0 ? (
    <span data-testid={testId} className="inline-flex items-center gap-1 rounded-full bg-[#d4f253] px-2.5 py-0.5 text-xs font-extrabold text-[#0f2a33]">
      <BadgeCheck className="h-3.5 w-3.5" /> Sold {count} item{count > 1 ? "s" : ""}
    </span>
  ) : null;
